import { render, staticRenderFns } from "./housekeepingDispatchManage.vue?vue&type=template&id=a13571ac&scoped=true"
import script from "./housekeepingDispatchManage.vue?vue&type=script&lang=js"
export * from "./housekeepingDispatchManage.vue?vue&type=script&lang=js"
import style0 from "./housekeepingDispatchManage.vue?vue&type=style&index=0&id=a13571ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a13571ac",
  null
  
)

export default component.exports